'use client';

import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';

interface CartActionsProps {
  onAddProcedure: () => void;
}

export function CartActions({ onAddProcedure }: CartActionsProps) {
  return (
    <div className="px-6 pb-5">
      <Button
        variant="secondary"
        startIcon={faPlus}
        startIconSize="1x"
        className="h-12 w-full text-lg"
        onClick={onAddProcedure}
        data-testid={DataTestIdEnum.CART_ADD_PROCEDURE_BUTTON}
      >
        Adicionar consulta ou exame
      </Button>
    </div>
  );
}
